import { render, staticRenderFns } from "./WorkingFileHeader.vue?vue&type=template&id=b56dbace&scoped=true&"
import script from "./WorkingFileHeader.vue?vue&type=script&lang=js&"
export * from "./WorkingFileHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkingFileHeader.vue?vue&type=style&index=0&id=b56dbace&prod&scoped=true&lang=css&"
import style1 from "./WorkingFileHeader.vue?vue&type=style&index=1&id=b56dbace&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56dbace",
  null
  
)

export default component.exports